/**
 * Contratação comercial de planos pagos (landing + fluxo de cadastro).
 * `true`: CTAs “Começar agora” para rotas pagas ficam desabilitados na home;
 * no cadastro, o gateway de pagamento é ignorado (ver `cadastro.vue`).
 * Altere aqui para reativar contratação paga em todo o front que importar esta constante.
 */
export const CONTRATACAO_PLANOS_PAGOS_DESABILITADA = true;
